import React, { FC } from 'react';
import { PARTNER_FEES_INPUTS } from '../../constants/new-partner/partner-fees-inputs';
import { FormInput } from '../merchants/FormInput';
import { useFormik } from 'formik';
import {
	convertToPartnerFeesInitialValues,
	getPartnerDetailsSchema,
	IPartnerFeesTypes, PARTNER_FEES_FORM_FIELDS, PARTNER_FEES_FORM_FIELDS_NAMES, partnerFeesInitialValues,
} from '../../constants/new-partner/partner-fees-form';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useParams } from 'react-router-dom';
import { setPartnerFees } from '../../store/merchnts/actions/partners';
import { Input } from '../developers/page-components/Input';
import { IPartnerFees } from '../../store/merchnts/merchant-interfaces';

interface Props {
	closeModal: () => void;
	onSuccess: () => void;
	onError: () => void;
	partnerFeeData?: IPartnerFees;
}
export const PartnerDetailsFeesModal: FC<Props> = (props) => {
  const { partnerFeeData, closeModal, onSuccess, onError } = props;
	const { partnerId } = useParams();
	const { merchantState: { isPartnerFeesAddingLoading, merchantsLists }, dispatch } = useMerchants();

	const formik = useFormik<IPartnerFeesTypes>({
		initialValues: partnerFeeData
			? convertToPartnerFeesInitialValues(partnerFeeData)
			: partnerFeesInitialValues,
		validationSchema: getPartnerDetailsSchema,
		onSubmit: () => setPartnerFees(dispatch, formik, partnerId, onSuccess, onError, partnerFeeData)
	});

	const INPUTS = PARTNER_FEES_INPUTS({ feeTypes: merchantsLists?.feeTypes });

	return (
		<form className="px-8 row" onSubmit={formik.handleSubmit}>
			{
				INPUTS.map(item => (
					<FormInput
						{...item}
						formik={formik}
						key={item.key}
					/>
				))
			}
			<div className="col-3 pt-10">
				<Input
					formik={formik}
					inputType="checkbox"
					fieldLabel={PARTNER_FEES_FORM_FIELDS_NAMES.IS_ACTIVE}
					checkboxFieldName={PARTNER_FEES_FORM_FIELDS.IS_ACTIVE}
				/>
			</div>

			<div className="text-center mt-10 mb-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName="Add"
					type="submit"
					additionalClass="btn-sm ms-10 w-70px"
					loading={isPartnerFeesAddingLoading}
					isDisabled={isPartnerFeesAddingLoading}
				/>
			</div>
		</form>
	);
};